export default __webpack_public_path__ + "static/media/spider-solid.1976d94d.svg";